import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsClientsTabsTabVoluntaryProgramActivity from 'components/form-fields-clients-tabs/tab-voluntary-program-activity/tab-voluntary-program-activity';
class EditViewPostDischargeTabVoluntaryProgramActivity extends Component {
  render() {
    return (
      <div>
        <FormFieldsClientsTabsTabVoluntaryProgramActivity {...this.props} locked={this.props.locked} />
      </div>
    );
  }
}
EditViewPostDischargeTabVoluntaryProgramActivity.propTypes = {
  locked: PropTypes.bool,
}
EditViewPostDischargeTabVoluntaryProgramActivity = reduxForm({
  form: 'PostDischargeEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewPostDischargeTabVoluntaryProgramActivity);
export default EditViewPostDischargeTabVoluntaryProgramActivity;